<template>
	<div class="leftres">
		<div>
			<!--  v-if="showorhide" -->
			<div class="inputtop">
				<template v-for="(item , index) of formdata">
					<Commondropdownlist :key="index" ref="select" :lablewith="item.lablewith" :options="item.options"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @cascaderchange="cascaderchange"></Commondropdownlist>
				</template>
				<div style="display: inline-block;float: right;margin-right: -10px;">
					<CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" :qhide="false"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
				<dataManagetable ref="dmt"></dataManagetable>
				<!--:tableData="tabledata"-->
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import dataManagetable from './components/dataManagetable.vue'
	import {
		GetMenusWithAuthorites,
		OrganizationList
	} from '@/api/home'
	import {
		DataDownloadClassListForNode,
	} from '@/api/channel'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			dataManagetable
		},
		data() {
			return {
				query: {

				},
				showorhide: false,
				formdata: [{
						title: "资料分类",
						modelvalue: "",
						inputtype: "cascaderNodeParent",
						fontSize: '14px',
						types: "select",
						placeholder: "请选择资料分类",
						width: '220px',
						options: []
					},
					{
						inputdata: "",
						title: '标题',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '220px'
					},
				],
				tabledata: [],
			}
		},
		mounted() {
			// this.getMenusWithAuthorites()
			// let e = this.$refs.select
			//console.log("ssss")
			// //console.log(e,"ss")

			this.organizationList()
			this.getHelperDataDownloadType();
		},
		methods: {
			// async getMenusWithAuthorites() {
			//   let {
			//     code,
			//     data
			//   } = await GetMenusWithAuthorites({

			//   })
			//   if (code == 0) {
			//     this.formdata[0].options = data
			//   }
			// },
			//获取文件类型
			async getHelperDataDownloadType() {
				let {
					code,
					message,
					data
				} = await DataDownloadClassListForNode({})
				if (code == 0) {
					this.formdata[0].options = data;
				} else {
					this.$message.warning(message)
				}
			},
			async organizationList() {
				let list = await OrganizationList({
					pageSize: 20,
					pageIndex: 0
				})
				if (list.code == 0) {
					this.tabledata = list.data.data
				}
				//console.log("list", list.data.data)
			},
			reset() {
				this.$refs.select.map((item, index) => {
					item.modelvalue = ''
				})
				this.$refs.dmt.DataDownloadListApi(this.$refs.select[0].modelvalue, this.$refs.select[1].modelvalue);
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			select() {
				this.$refs.dmt.DataDownloadListApi(this.$refs.select[0].modelvalue, this.$refs.select[1].modelvalue);
			},
			cascaderchange(e) {
				this.NodeID = e[e.length - 1]
				//console.log(e[e.length - 1], "e")
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		animation: shows 0.2s ease-in;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		overflow: hidden;
		// animation: hides 0.5s ease-in;
	}

	@keyframes shows {
		0% {
			height: 0px;
		}

		100% {
			height: 40px;
		}
	}

	@keyframes hides {
		0% {
			height: 40px;
		}

		100% {
			height: 0px;
		}
	}
</style>